import React from "react";
import GameItem from "./GameItem";
import { checkBonusGame, updateImageUrl } from "../../../utils/utils.js";

export default function GameItemSupportBonus({ currentGame, origImage, ...props }) {
  const isBonus = checkBonusGame(currentGame);
  let newCurrentGame = { ...currentGame };

  const itemImg =
    origImage || isBonus ? newCurrentGame.image : updateImageUrl(newCurrentGame.image);

  return (
    <GameItem
      {...props}
      currentGame={newCurrentGame}
      name={newCurrentGame.name}
      image={itemImg}
      url={isBonus ? "/bonus_game/" : props.url}
    />
  );
}
